import { useQuery } from '@tanstack/react-query'

// Type for the result of a query hook
export type QueryHookResult<T> = {
  data: T[]
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => Promise<T[]>
}

// Interface for query options
export interface QueryOptions<T> {
  queryKey: readonly unknown[]
  queryFn: () => Promise<T[]>
  enabled?: boolean
}

// Generic query hook that can be used for any type of data
export function useGenericQuery<T>(options: QueryOptions<T>): QueryHookResult<T> {
  const { queryKey, queryFn, enabled = true } = options
  
  const result = useQuery({
    queryKey,
    queryFn,
    enabled,
  })

  return {
    data: result.data || [],
    isLoading: result.isLoading,
    isError: result.isError,
    error: result.error,
    refetch: queryFn
  }
}

// Register of query hooks by name
export type QueryHookRegistry<T = unknown> = Record<string, (...args: unknown[]) => QueryHookResult<T>>
